import { render, staticRenderFns } from "./cadenas.vue?vue&type=template&id=89f9e308&scoped=true&"
import script from "./cadenas.vue?vue&type=script&lang=js&"
export * from "./cadenas.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "89f9e308",
  null
  
)

export default component.exports